import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik, } from "formik";
import * as Yup from "yup";
import * as moment from "moment";
import { downloadFile } from "redux/actions/helper/downloadFile";
import Spinner from 'web/components/Spinner'
import AlertModal from 'web/components/AlertModal';
import YesNoModal from "web/components/YesNoModal";
import FileUploader from 'web/components/FileUploader';
import { Modal, ModalBody } from 'reactstrap';
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import { PickupDetailsModalWrapper, PickupDetailsModalContentWrapper } from "./modalStyled";
import CloseIcon from "web/assets/images/CloseIcon.png";
import DatePickerIcon from 'web/assets/svg/DatePickerIcon';
import { palletTypeOptions, claimTypeConstants } from "./Constants";
import NumberInput from "web/components/form-elements/NumberInput";
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import TextArea from 'web/components/form-elements/TextArea';
import { uploadSpec } from "redux/actions/postLoad";
import { claimRaiseApi, claimAcceptDeclineApi } from "redux/actions/myPickupOrders";
import EditIcon from "web/assets/images/edit-icon.png";

function ClaimRaiseResolveModal(props) {
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible)
  const { modalData, claimRaiseResolveType } = props
  const token = localStorage.getItem("token")
  const dispatch = useDispatch();
  let history = useHistory();
  const [loader, setLoader] = useState(false)
  const [qtyFieldEnable, setQtyFieldEnable] = useState(false)
  const [pickupDetailsStore, setPickupDetailsStore] = useState()
  const [alertModal, setAlertModal] = useState(false)
  const [alertModalContent, setAlertModalContent] = useState('')
  const [yesNoModalContent, setYesNoModalContent] = useState("");
  const [yesNomodal, setYesNoModal] = useState(false);
  const [alertType, setModalType] = useState()

  const initialValues = () => {
    return (
      {
        estQty: modalData?.quantity,
        note: '',
        qtyClaimType: false,
        docClaimType: false,
        claimRaiseDOCs: []
      }
    )
  }

  const VALIDATION_SCHEMA = () => {
    let schemaAttributes = {};

    if (claimRaiseResolveType === 'decline') {
      schemaAttributes = {
        note: Yup.string().required('Reject note is required').max(200, 'Comment must be at most 200 characters'),
        estQty: Yup.number().required('Quantity is required').min(1, 'Quantity must be greater than 0')
      };
    } else if (claimRaiseResolveType === 'raise') {
      schemaAttributes = {
        estQty: Yup.number().required('Quantity is required').min(1, 'Quantity must be greater than 0'),
        note: Yup.string().required('Discrepancy details is required').max(200, 'Comment must be at most 200 characters'),
        qtyClaimType: Yup.boolean(),
        docClaimType: Yup.boolean(),
      };
    }

    return Yup.object().shape(schemaAttributes).noUnknown().strict(false);
  };

  const submitForm = async (values) => {
    setPickupDetailsStore(values)
    setYesNoModalContent(claimRaiseResolveType === 'raise' ? 'Are you sure you want to raise the claim?' : claimRaiseResolveType === 'decline' ? 'Are you sure you want to reject this claim?' : 'Are you sure you want to accept the claim?')
    setYesNoModal(true)
    setModalType('claimConfirmation')
  }

  const claimRaiseFunction = async (values) => {
    setLoader(true)
    let documents = values?.claimRaiseDOCs || []
    let formData, uploadResponse
    if (documents.length > 0) {
      formData = new FormData();
      documents.map((data) => formData.append("uploadSpecification", data))
      uploadResponse = await dispatch(uploadSpec(formData, ''));
    }
    if (uploadResponse?.status === "SUCCESS" || documents.length === 0) {
      let claimTypeVal = []
      if (values.qtyClaimType) claimTypeVal.push('INCORRECT_QTY')
      if (values.docClaimType) claimTypeVal.push('INCORRECT_BOL')
      let data = {
        locationId: localStorage.getItem('locationID'),
        orderId: modalData?.orderId,
        qty: values.estQty,
        uploadedDocs: uploadResponse?.payload || [],
        comment: values.note,
        claimType: claimTypeVal
      }
      let response = await dispatch(claimRaiseApi(data, token));
      if (response?.success) {
        setLoader(false)
        setModalType('claimRaiseSuccess')
        setAlertModalContent('Claim has been raised successfully.');
        setAlertModal(!alertModal)
      } else {
        setLoader(false)
        if (response?.statusCode === 401) {
          history.push('./sign-in')
        } else {
          setAlertModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setAlertModal(!alertModal);
        }
      }
    } else {
      if (uploadResponse?.statusCode === 401) {
        history.push('./sign-in')
      } else {
        setLoader(false)
        setAlertModal(!alertModal)
        setAlertModalContent(uploadResponse?.data?.error?.message || 'File upload failed, please try again.');
      }
    }
  }

  const claimAcceptDeclineFunction = async (values) => {
    setLoader(true)
    let data = {
      locationId: localStorage.getItem('locationID'),
      orderId: modalData?.orderId,
      status: "ACCEPTED"
    }
    if (claimRaiseResolveType === 'decline') {
      data.status = "REJECTED"
      data.rejectNote = values.note
      data.qty = values.estQty
    }
    let response = await dispatch(claimAcceptDeclineApi(data, token));
    if (response?.success) {
      setLoader(false)
      setModalType(claimRaiseResolveType === 'decline' ? 'claimDeclineSuccess' : 'claimAcceptSeccess')
      setAlertModalContent(claimRaiseResolveType === 'decline' ? 'Claim has been rejected successfully.' : 'Claim has been accepted successfully.');
      setAlertModal(!alertModal)
    } else {
      setLoader(false)
      if (response?.statusCode === 401) {
        history.push('./sign-in')
      } else {
        setAlertModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setAlertModal(!alertModal);
      }
    }
  }

  const getLabelFromValue = (value) => {
    const option = palletTypeOptions.find(option => option.value === value);
    return option ? option.label : '';
  };

  const downloadFiles = file => {
    dispatch(downloadFile(file));
  }

  const checkIsValid = (isValid, dirty, values) => {
    if (claimRaiseResolveType === 'accept') return !isValid
    else if (claimRaiseResolveType === 'decline') return (!dirty || !isValid)
    else if (claimRaiseResolveType === 'raise') {
      let isClaimTypeSelected = values.qtyClaimType || values.docClaimType
      return (!dirty || !isValid || !isClaimTypeSelected)
    }
  }

  return (
    <PickupDetailsModalWrapper>
      <Modal isOpen={true} centered={true} size={'lg'} className="pickuporder-details-modal">
        <PickupDetailsModalContentWrapper>
          <ModalBody>
            {(loaderVisible || loader) && <Spinner />}
            <Formik
              initialValues={initialValues()}
              validationSchema={VALIDATION_SCHEMA()}
            >
              {(formikProps) => {
                const { isValid, dirty, setFieldValue, values, errors, setFieldError } = formikProps;
                return (
                  <div className="outer-wrapper">
                    <div className="main-header">
                      <h4>Details of Pickup Order Claim</h4>
                      <img src={CloseIcon} alt="close-icon" onClick={() => props.closeModal()} />
                    </div>
                    <div className="location-details-styles">
                      <div>
                        <p>Company Name</p>
                        <span>{modalData?.pickupLocation?.locationName}</span>
                      </div>
                      <div>
                        <p>Pickup Address</p>
                        <span>{modalData?.pickupLocation?.address1}, {modalData.pickupLocation?.city}, {stateConvert(modalData.pickupLocation?.state) || modalData.pickupLocation?.state} {modalData.pickupLocation?.zipCode}</span>
                      </div>
                    </div>
                    <div className="pickup-details-styles">
                      <div>
                        <p>Picked Up Date</p>
                        <div className="date-picker-style">
                          <DatePickerIcon />
                          <span>{moment(modalData?.pickupDate).format('MM/DD/YYYY')}</span>
                        </div>
                      </div>
                      <div>
                        <p>Picked Up Time</p>
                        <span>{modalData?.pickupAppointmentStartTime} <span style={{ margin: '0 10px' }}>To</span> {modalData?.pickupAppointmentEndTime}</span>
                      </div>
                      <div>
                        <p>Ref Number</p>
                        <span>{modalData?.ptplusRefNumber}</span>
                      </div>
                      <div>
                        <p>Estimated Qty</p>
                        {(claimRaiseResolveType === 'decline' || claimRaiseResolveType === 'raise') ?
                          <div className="qty-style">
                            <NumberInput
                              name='estQty'
                              showErrorMessages={true}
                              placeholder=""
                              decimalScale={0}
                              maxLength={4}
                              disabled={!qtyFieldEnable}
                              onChangeHandler={(val) => setFieldValue('quantity', val)}
                            />
                            <img src={EditIcon} alt="edit icon" onClick={() => setQtyFieldEnable(true)} />
                          </div>
                          :
                          <span>{modalData?.quantity}</span>
                        }
                      </div>
                    </div>
                    <hr />
                    <div className="pallet-type-styles">
                      <>
                        <div className="header">
                          <p>Pallet Type</p>
                          <p>Picked Up Qty</p>
                        </div>
                        <div className="content">
                          {modalData?.pickedupDetails?.palletList?.map((data, index) => (
                            <div key={`adding-new-${index}`} className="content-rows selcted-pallets-styles">
                              <input value={getLabelFromValue(data?.palletType)} disabled />
                              <input value={data?.qty} disabled />
                            </div>
                          ))}
                        </div>
                        <div className="content-rows">
                          <p style={{ textAlign: 'right', color: '#000' }}>Total Quantity : </p>
                          <h6><span className="total-qty-style" style={{ marginLeft: '10px' }}>{modalData.pickedupDetails?.palletList?.reduce((acc, data) => acc + data.qty, 0)}</span></h6>
                        </div>
                      </>
                    </div>
                    <hr />
                    <div className="uploaded-files-styles">
                      <p>Uploaded Files</p>
                      <div className="files-list">
                        {modalData?.pickedupDetails?.uploadedDocs?.map(data => (
                          <span onClick={() => downloadFiles(data?.fileName)}>{data?.orignalFileName}</span>
                        ))}
                      </div>
                    </div>
                    {claimRaiseResolveType === 'raise' &&
                      <div className="claim-type-section">
                        <p>Claim Reason<span className="star">*</span></p>
                        <div className="check-box-wrapper">
                          {claimTypeConstants.map(data => {
                            return (
                              <CheckboxInput
                                name={data.value}
                                label={data.label}
                                handleSelect={() => { }}
                              />
                            )
                          })}
                        </div>
                        <div>
                          <FileUploader maxFiles={3} onUploadOrRemove={(files) => setFieldValue('claimRaiseDOCs', files)} mandatory='no' />
                        </div>
                      </div>
                    }
                    {(claimRaiseResolveType === 'decline' || claimRaiseResolveType === 'raise') &&
                      <div className="comment-section-style">
                        <p>{claimRaiseResolveType === 'decline' ? 'Reject Note' : 'Discrepancy Details'}<span className="star">*</span></p>
                        <TextArea
                          name="note"
                          maxLength="200"
                        />
                      </div>
                    }
                    {(claimRaiseResolveType === 'accept' || claimRaiseResolveType === 'decline') && (
                      <div className="claim-acknowledge-style">
                        {claimRaiseResolveType === 'accept' ?
                          <p>By accepting this revised quantity, the total recorded by the supplier will overwrite the original estimation that was requested.</p> :
                          <p>By rejecting this claim, it will move this order back to scheduled and request that the supplier re-upload the completed pickup sort form. Note, you have the option to adjust the original requested quantity, if required.</p>
                        }
                      </div>
                    )}
                    <div className="submit-button">
                      <button
                        disabled={checkIsValid(isValid, dirty, values)}
                        onClick={() => submitForm(values)}
                      >{claimRaiseResolveType === 'accept' ? 'Accept' : claimRaiseResolveType === 'decline' ? 'Reject' : 'Submit'}</button>
                    </div>
                  </div>
                );
              }}
            </Formik>
          </ModalBody>
        </PickupDetailsModalContentWrapper>
      </Modal>

      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        content={alertModalContent}
        alertType='success'
        callBackAlert={() => {
          if (alertType === 'claimRaiseSuccess') {
            props.closeModal()
            props.claimRaiseSuccessCallBack()
          } else if (alertType === 'claimDeclineSuccess') {
            props.closeModal()
            props.claimDeclineSuccessCallBack()
          } else if (alertType === 'claimAcceptSeccess') {
            props.closeModal()
            props.claimAcceptSuccessCallBack()
          }
        }}
      />
      <YesNoModal
        isOpen={yesNomodal}
        toggle={() => setYesNoModal(!yesNomodal)}
        title=""
        content={yesNoModalContent}
        link={'/'}
        type={''}
        onClickHander={(val) => {
          setYesNoModal(!yesNomodal)
          if (val !== "no" && alertType === 'claimConfirmation') {
            if (claimRaiseResolveType === 'raise') claimRaiseFunction(pickupDetailsStore)
            else claimAcceptDeclineFunction(pickupDetailsStore)
          }
        }}
      />
    </PickupDetailsModalWrapper>
  );
}

export default ClaimRaiseResolveModal;
